import React from 'react';
import './Footer.css'
import InstagramIcon from '@mui/icons-material/Instagram';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import Stack from '@mui/material/Stack';
import CopyrightOutlinedIcon from '@mui/icons-material/CopyrightOutlined';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import companyInfo from "../../config/companyInfo.json";
import { aws_cloudfront_domain_name } from '../../common/commonUtils';

function getGoogleMapUrl() {
  let urlAddress = "https://www.google.com/maps/place/"
  for (let i = 0; i < companyInfo.physicalAddress.length; i++) {
    urlAddress += companyInfo.physicalAddress[i].split(" ").join("+") + ",+"
  }
  return urlAddress.substring(0, urlAddress.length - 2)
}

/* Mobile icon row: Instagram then Email */
function IconListShort() {
  return (
      <div className="short-list">
        <ul>
          <li>
            <a href={`https://www.instagram.com/${companyInfo.instagramHandle}/`}>
              <InstagramIcon />
            </a>
          </li>
          <li>
            <a href={`mailto:${companyInfo.email}`}>
              <EmailOutlinedIcon />
            </a>
          </li>
        </ul>
      </div>
  )
}

/* Desktop long layout */
function IconListLong() {
  return (
      <div className='long-list'>
        <ul>
          <li>
            <Stack direction="row" spacing={2}>
              <PlaceOutlinedIcon />
              <a href={getGoogleMapUrl()}>
                {companyInfo.physicalAddress.map((line, index) =>
                    <div key={index}>{line}</div>
                )}
              </a>
            </Stack>
          </li>

          <li>
            <Stack direction="row" spacing={2}>
              <LocalPhoneOutlinedIcon />
              <a href={`tel:${companyInfo.phoneNumber}`}>
                ({companyInfo.phoneNumber.substring(0, 3)}) {companyInfo.phoneNumber.substring(4, 7)}-{companyInfo.phoneNumber.substring(8, 12)}
              </a>
            </Stack>
          </li>

          <li>
            <Stack direction="row" spacing={2}>
              <EmailOutlinedIcon />
              <a href={`mailto:${companyInfo.email}`}>{companyInfo.email}</a>
            </Stack>
          </li>

          <li>
            <Stack direction="row" spacing={2}>
              <InstagramIcon />
              <a href={`https://www.instagram.com/${companyInfo.instagramHandle}/`}>@{companyInfo.instagramHandle}</a>
            </Stack>
          </li>
        </ul>
      </div>
  )
}

function CopyrightLogo() {
  return (
      <Stack direction="row" spacing={1}>
        <div>Copyright</div>
        <CopyrightOutlinedIcon fontSize='small' />
        <div>{new Date().getFullYear()}</div>
        <div>All rights reserved</div>
      </Stack>
  )
}

export default function Footer() {
  return (
      <footer className='footer'>
        <div className="footer-inner">

          <div className='footer-logo'>
            <img
                src={aws_cloudfront_domain_name + "/logosAndIcons/ch_logo.png"}
                alt="Copper & Honey"
            />
          </div>

          {/* Desktop layout */}
          <div className="footer-content-desktop">
            <IconListLong />
          </div>

          {/* Mobile layout */}
          <div className="footer-content-mobile">

            <div className="mobile-stack">

              {/* FULL address */}
              <div className="mobile-item mobile-address">
                <PlaceOutlinedIcon />
                <a href={getGoogleMapUrl()}>
                  Lincoln, CA
                </a>
              </div>

              {/* Phone stays spelled out */}
              <div className="mobile-item">
                <LocalPhoneOutlinedIcon />
                <a href={`tel:${companyInfo.phoneNumber}`}>
                  ({companyInfo.phoneNumber.substring(0, 3)}) {companyInfo.phoneNumber.substring(4, 7)}-{companyInfo.phoneNumber.substring(8, 12)}
                </a>
              </div>

            </div>

            {/* Icons go UNDER the contact stack */}
            <IconListShort />
          </div>

          <div className='footer-right'>
            <CopyrightLogo />
          </div>

        </div>
      </footer>
  )
}